import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'

import Newsletter from './Newsletter.vue'
import ET from './ET.vue'
import Franchise from './Franchise.vue'
import Contact from './Contact.vue'
import LocationFinder from './LocationFinder.vue'

import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';

export default function initForms() {

  const i18n = createI18n({
    legacy: false,
    warnHtmlMessage: false,
    locale: document.documentElement.lang,
    fallbackLocale: 'en',
    messages: {
      de: de,
      en: en,
      fr: fr
    }
  });

  if(document.querySelectorAll('[data-form="Newsletter"]').length) {
    const newsletter = createApp(Newsletter);
    newsletter.use(i18n);
    newsletter.mount('[data-form="Newsletter"]');
  }

  if(document.querySelectorAll('[data-form="Contact"]').length) {
    const contact = createApp(Contact);
    contact.use(i18n);
    contact.mount('[data-form="Contact"]');
  }

  if(document.querySelectorAll('[data-form="ET"]').length) {
    const et = createApp(ET);
    et.use(i18n);
    et.mount('[data-form="ET"]');
  }

  if(document.querySelectorAll('[data-form="Franchise"]').length) {
    const franchise = createApp(Franchise);
    franchise.use(i18n);
    franchise.mount('[data-form="Franchise"]');
  }

  if(document.querySelectorAll('[data-form="LocationFinder"]').length) {
    const locationfinder = createApp(LocationFinder);
    locationfinder.use(i18n);
    locationfinder.mount('[data-form="LocationFinder"]');
  }
}

